import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { EducationService } from '../../services/education.service';
import { Observable } from 'rxjs';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatSortModule, MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, ValidationErrors, FormControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
	selector: 'app-education-rewards',
	templateUrl: './education-rewards.component.html',
	styleUrls: ['./education-rewards.component.scss']
})
export class EducationRewardsComponent {
	color = '';
	loclist: any = [];
	@ViewChild('setupModal') setupRef: ElementRef;
	locForm: UntypedFormGroup;
	selectedLoc: any = false;
	
	dataSource: MatTableDataSource < any > ;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataObs: Observable < any > ;
	items_per_page = [5, 10, 20 , 100, 500, 1000];
	pagesizedefault = 20;
	loading: any = false;
	
	constructor(private _changeDetectorRef: ChangeDetectorRef, private fb: UntypedFormBuilder, private educationService: EducationService, private globalSearchService: GlobalSearchService, private route: ActivatedRoute, public router: Router, private location: Location, private modalService: NgbModal) {
		this.color = this.globalSearchService.getColor();
		
		this.educationService.getRewards().subscribe((a) => {
			if(a){
				this.loclist = a;
			}
			this.setPagination([]);
			this.setPagination(this.loclist);
			this.locForm = this.fb.group({
				name: ['', Validators.required],
				type: ['1'],
				text: [''],
				notes: [''],
				enabled: [true],
			});
		});
		
		
	}
	
	setPagination(tableData) {
		this.dataSource = new MatTableDataSource <any> (tableData);
		this._changeDetectorRef.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();

	}
	
	back(): void {
		this.location.back()
	}
	
	addReward(){
		this.selectedLoc = null;
		this.locForm = this.fb.group({
			name: ['', Validators.required],
			type: ['1'],
			text: [''],
			notes: [''],
			enabled: [true],
		});
		this.modalService.open(this.setupRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}
	
	editReward(loc: any){
		this.selectedLoc = loc;
		this.locForm = this.fb.group({
			name: [loc.name, Validators.required],
			type: [loc.type],
			text: [loc.text],
			notes: [loc.notes],
			enabled: [loc.enabled],
		});
		this.modalService.open(this.setupRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}
	
	saveReward(){
		
		if(this.locForm.valid){
			const data = { id: this.selectedLoc?.id, reward: this.locForm.value };
		
			this.educationService.saveReward(data).subscribe((a) => {
				this.loclist = a;
				this.setPagination(this.loclist);
				this.selectedLoc = [];
				this.modalService.dismissAll();
			});
		} else {
		 this.getFormValidationErrors(this.locForm);
		}
	}
	deleteReward(loc: any){
		const data = { id: loc.id };
		this.educationService.deleteReward(data).subscribe((a) => {
			this.loclist = a;
			this.setPagination([]);
			this.setPagination(this.loclist);
		});
	}
	
	getFormValidationErrors(form: any) {
		Object.keys(form.controls).forEach((key, index) => {
			const controlErrors: ValidationErrors = form.get(key).errors;

			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					//this.customerForm.controls[index].markAsTouched()
					form.markAllAsTouched();
					//form.markAsUntouched()

					this.globalSearchService.showNotification(key + ' ' + keyError, 'danger', 'bottom', 'right')
				});
			}
		});
	}
}
